import { CanaryStatus } from '@thyme/libs/src/version/types'

// TYPES --------------------
export type ReportIssueForm = {
  route: string
  issueType: string
  fullUrl: string | null
  description: string
  reporter: string
  reporterId: string
  checkedDebugSteps: { [key: string]: boolean }
  uiVersion: string
  canaryStatus: CanaryStatus
}

export type ReportIssueDebugCheckboxOption = {
  label: string
  link?: string
}

// CONSTANTS ----------------

export const DEFAULT_PATIENT_PROFILE_ISSUE_TYPES = [
  'Page not loading',
  'Calling not working',
  'Patient sidebar issue',
  'Playbook/Task issue',
  'Other',
]

export const DEFAULT_QUEUE_ISSUE_TYPES = [
  'Page not loading',
  'Assigned queue',
  'Unassigned queue',
  'Filters not working',
  'Other',
]

export const DEFAULT_DEBUG_STEPS = [
  {
    label: 'I cleared my browser cache',
    link: 'https://support.google.com/accounts/answer/32050',
  },
  {
    label: 'I confirmed that my VPN is connected',
    link: 'https://app.gitbook.com/o/-MbN892xoO-71tzzZ9Yf/s/-MkCyG1YxEnT-aLhAhNp/openvpn-connect/import-vpn-profile-to-openvpn',
  },
  { label: 'I logged out and back into my Gmail account' },
]

export const reportIssueTypesForRouteMap: Record<string, string[]> = {
  '#myQueue': ['My Schedule not working', ...DEFAULT_QUEUE_ISSUE_TYPES],
  '#enrollmentQueue': ['My Schedule not working', ...DEFAULT_QUEUE_ISSUE_TYPES],
  '#leadQueue': [...DEFAULT_QUEUE_ISSUE_TYPES],
  '#enrollmentLeadQueue': [...DEFAULT_QUEUE_ISSUE_TYPES],
  '#patients': [
    'Page not loading',
    'Search Issue',
    'Filters not working',
    'Other',
  ],
  '#allTasks': [
    'Page not loading',
    'Search not working',
    'Filters not working',
    'Other',
  ],
  '#patientProfile': [
    'Page not loading',
    'Thymeline not working',
    'Texting not working',
    ...DEFAULT_PATIENT_PROFILE_ISSUE_TYPES,
    'Care Plan issue',
    'Other',
  ],
  '#patientProfileCarePlan': [
    'Care Plan issue',
    ...DEFAULT_PATIENT_PROFILE_ISSUE_TYPES,
  ],
  '#patientProfileClinicalSummary': [
    'Cancer section not working or loading',
    'Treatment section not working or loading',
    'Medical Conditions section not working or loading',
    'Fall Risk section not working or loading',
    'Physical Function section not working or loading',
    'Transitions of Care section not working or loading',
    'Medical Team section not working or loading',
    ...DEFAULT_PATIENT_PROFILE_ISSUE_TYPES,
  ],
  '#patientProfileSocialSummary': [
    'Social Summary section not working or loading',
    ...DEFAULT_PATIENT_PROFILE_ISSUE_TYPES,
  ],
  '#patientProfileHistory': [
    'History table not working or loading',
    ...DEFAULT_PATIENT_PROFILE_ISSUE_TYPES,
  ],
  '#patientProfileToDo': [
    'To Do table not working or loading',
    ...DEFAULT_PATIENT_PROFILE_ISSUE_TYPES,
  ],
  '#patientProfileSymptoms': [...DEFAULT_PATIENT_PROFILE_ISSUE_TYPES],
  '#patientProfileTexting': [
    'Texting not working',
    ...DEFAULT_PATIENT_PROFILE_ISSUE_TYPES,
  ],
  '#patientProfileMedicalContext': [
    'Appointments tab not working or loading',
    'Claims tab not working or loading',
    'Comorbidities tab not working or loading',
    'Oncology Diagnoses tab not working or loading',
    'Oncology Treatments tab not working or loading',
    'TOCs tab not working or loading',
    ...DEFAULT_PATIENT_PROFILE_ISSUE_TYPES,
  ],
  '#patientProfileDocuments': [
    'Active Documents table not working or loading',
    'Archived Documents table not working or loading',
    ...DEFAULT_PATIENT_PROFILE_ISSUE_TYPES,
  ],
  // IMPROVEME(MT-3265): post-pilot, add Admin pages
  '#admin/users': ['Page not loading', 'Other'],
  // Default/catch-all case
  '': ['Other'],
}
